<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="扩展字段名称" prop="extendFieldName">
            <el-input
              clearable
              v-model="formData.extendFieldName"
              placeholder="请输入扩展字段名称"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="界面控件类型" prop="controlType">
            <el-select
              v-model="formData.controlType"
              placeholder="请选择界面控件类型"
              style="width:100%"
            >
              <el-option label="文本框" value="input" />
              <el-option label="下拉框" value="select" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="字段类型" prop="fieldType">
            <el-select
              v-model="formData.fieldType"
              placeholder="请选择字段类型"
              style="width:100%"
            >
              <el-option label="文本" value="text" />
              <el-option
                label="数值"
                value="number"
                :disabled="isDisabledFieldType"
              />
              <el-option
                label="日期"
                value="date"
                :disabled="isDisabledFieldType"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 18 }" :lg="{ span: 12 }">
          <el-form-item label="字段顺序" prop="sortOrder">
            <el-input-number
              clearable
              v-model="formData.sortOrder"
              placeholder="请输入字段顺序"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="1"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 18 }" :lg="{ span: 12 }">
          <el-form-item label="字段长度" prop="fieldLength">
            <el-input-number
              clearable
              v-model="formData.fieldLength"
              placeholder="请输入字段长度"
              controls-position="right"
              style="width:100%"
              :disabled="isDisabledFieldLength"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="是否必填" prop="isRequired">
            <el-radio-group v-model="formData.isRequired">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="是否多选" prop="isMultiple">
            <el-radio-group v-model="formData.isMultiple">
              <el-radio label="Y" :disabled="isDisabledMultiple">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="是否使用" prop="isEnable">
            <el-radio-group v-model="formData.isEnable">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-form-item label="控件属性定义json">
          <el-input
            clearable
            type="textarea"
            v-model="formData.controlProps"
            placeholder="请输入控件属性定义json"
          >
          </el-input>
        </el-form-item>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    extendFieldCode: String,
  },
  data() {
    return {
      isDisabledFieldType: false,
      isDisabledFieldLength: false,
      isDisabledMultiple: false,
      backDialogVisible: false,
      formData: { isRequired: 'Y', isMultiple: 'Y', isEnable: 'Y' },
      rules: {
        extendFieldName: [
          { required: true, message: '请输入扩展字段名称', trigger: 'blur' },
        ],
        controlType: [
          { required: true, message: '请选择界面控件类型', trigger: 'change' },
        ],
        fieldType: [
          { required: true, message: '请选择字段类型', trigger: 'change' },
        ],
        fieldLength: [
          { required: true, message: '请输入字段长度', trigger: 'blur' },
        ],
        isRequired: [
          { required: true, message: '请选择是否必填', trigger: 'change' },
        ],
        isMultiple: [
          { required: true, message: '请选择是否多选', trigger: 'change' },
        ],
        sortOrder: [
          { required: true, message: '请输入字段顺序', trigger: 'blur' },
        ],
        isEnable: [
          { required: true, message: '请选择是否使用', trigger: 'change' },
        ],
      },
    }
  },
  watch: {
    /**
     * 侦听界面控件类型属性，修改字段类型并禁用元素，修改是否多选并禁用元素
     */
    'formData.controlType'() {
      if (this.formData.controlType === 'input') {
        this.formData.isMultiple = 'Y'
        this.isDisabledMultiple = false
        this.isDisabledFieldType = false
      } else {
        this.formData.isMultiple = 'N'
        this.isDisabledMultiple = true
        this.formData.fieldType = 'text'
        this.isDisabledFieldType = true
      }
    },
    /**
     * 侦听字段类型属性，清零字段长度，并禁用组件
     */
    'formData.fieldType'() {
      if (this.formData.fieldType === 'date') {
        this.formData.fieldLength = 0
        this.isDisabledFieldLength = true
      } else {
        this.isDisabledFieldLength = false
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.extendFieldCode) return
      this.$api
        .sysExtendFieldDetailApi({
          extendFieldCode: this.extendFieldCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .sysExtendFieldSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
